import {
  HeroSection,
  WhyRedBookSection,
  WhatWeDoSection,
  PostTypesSection,
  PricingSection,
  CTASection,
} from "./sections";
import {
  nihaoBridgeContentTh,
  nihaoBridgeContentVn,
  type SupportedLocale,
} from "./content";

interface NihaoBridgePageProps {
  locale: SupportedLocale;
}

const contentMap = {
  th: nihaoBridgeContentTh,
  vn: nihaoBridgeContentVn,
};

export default function NihaoBridgePage({ locale }: NihaoBridgePageProps) {
  const content = contentMap[locale];

  return (
    <div className="w-full">
      <HeroSection content={content.hero} />
      <WhyRedBookSection content={content.whyRedBook} />
      <WhatWeDoSection content={content.whatWeDo} />
      <PostTypesSection content={content.postTypes} />
      <PricingSection content={content.pricing} />
      <CTASection content={content.cta} />
    </div>
  );
}
